import { render } from "./insure-report.vue?vue&type=template&id=19801034&scoped=true&ts=true"
import script from "./insure-report.vue?vue&type=script&lang=ts"
export * from "./insure-report.vue?vue&type=script&lang=ts"

import "./insure-report.vue?vue&type=style&index=0&id=19801034&lang=stylus&scoped=true"

import exportComponent from "D:\\Repository\\Zidan\\pc-customer-admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19801034"]])

export default __exports__